const NAMESPACE = "enableIncentiveDesignDialog";

const KEYS = {
    enableDialogTitle: "enableDialogTitle",
    enableMessageHeader: "enableMessageHeader",
    enableMessageBody: "enableMessageBody",
    enableWarningMessage: "enableWarningMessage",
    enableCancelButtonText: "enableCancelButtonText",
    enableOkButtonText: "enableOkButtonText",
    disableDialogTitle: "disableDialogTitle",
    disableMessageHeader: "disableMessageHeader",
    disableMessageBody: "disableMessageBody",
    disableCancelButtonText: "disableCancelButtonText",
    disableOkButtonText: "disableOkButtonText"
};

const MESSAGES = {
    [KEYS.enableDialogTitle]: {
        value: "Confirm: Enable Incentive Design",
        comment: "Title for dialog used to confirm enabling an incnetive design"
    },
    [KEYS.enableMessageHeader]: {
        value: "Are you sure you want to enable this incentive design?",
        comment: "Message header in dialog used to confirm enabling an incentive design"
    },
    [KEYS.enableMessageBody]: {
        value:
            "Enabling an incentive design will make it an available option on all forms with an incentive selector element" +
            " (assuming all eligibility conditions and start/expiration date restrictions are satisfied)." +
            " An incentive design may be disabled at any time.",
        comment: "Message body in dialog used to confirm enabling an incentive design"
    },
    [KEYS.enableWarningMessage]: {
        value: "Once an incentive design has been enabled, it can never be edited again, even if it has later been disabled.",
        comment: "Warning message in dialog used to confirm enabling an incentive design"
    },
    [KEYS.enableCancelButtonText]: {
        value: "No - Cancel",
        comment: "Label on the Cancel button in the dialog used to confirm enabling an incentive design"
    },
    [KEYS.enableOkButtonText]: {
        value: "Yes - Enable",
        comment: "Label on the OK button in the dialog used to confirm enabling an incentive design"
    },
    [KEYS.disableDialogTitle]: {
        value: "Confirm: Disable Incentive Design",
        comment: "Title for dialog used to confirm disabling an incentive design"
    },
    [KEYS.disableMessageHeader]: {
        value: "Are you sure you want to disable this incentive design?",
        comment: "Message header in dialog used to confirm disabling an incentive design"
    },
    [KEYS.disableMessageBody]: {
        value:
            "Disabling an incentive design will remove it as an option from all incentive selector elements on forms" +
            " (until it is re-enabled). Projects already using this incentive design will not be affected by disabling it, however.",
        comment: "Message body in dialog used to confirm disabling an incentive design"
    },
    [KEYS.disableCancelButtonText]: {
        value: "No - Cancel",
        comment: "Label on the Cancel button in the dialog used to confirm disabling an incentive design"
    },
    [KEYS.disableOkButtonText]: {
        value: "Yes - Disable",
        comment: "Label on the OK button in the dialog used to confirm disabling an incentive design"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
